var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expand-y",style:({ height: _vm.height + 'px' })},[_c('div',{ref:"content",staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }